<script setup lang="tsx">
import { useI18n } from 'vue-i18n'
import VueMarkdown from 'vue-markdown-render'

const props = defineProps({
	isEdit: Boolean,
	isCustom: Boolean,
})

const model = defineModel<string>({ required: true })
const { t } = useI18n()
</script>

<template>
	<div class="card">
		<div class="card-body">
			<h6 class="card-title text-center fw-bold">
				{{ t('risk.description') }}
			</h6>

			<textarea
				v-if="props.isEdit && props.isCustom"
				:class="['mt-1', 'form-control', { 'is-invalid': !model.length }]"
				class="mt-1 form-control"
				maxlength="500"
				v-model="model"
				:placeholder="t('risk.riskDescription')"
			/>

			<div v-else>
				<VueMarkdown :source="model" :options="{ html: true }" />
			</div>
		</div>
	</div>
</template>
